module.exports = require("@swa-ui/application/src/Version/VersionInformation.module.scss");